<template>
  <CommonVariationView
    type="variation"
    reporter="employer"
    :contract="contract"
    :items="items"
    @FETCH_DATA="handleFetchData"
    :form-fields="formFields"
  />
</template>

<script>
import { getVariationsForContract } from '../services'
export default {
  name: 'VariationsView',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      items: [],
      formFields: ['stage', 'workstream', 'category', 'unlock', 'finalize', 'stageChange']
    }
  },
  mounted () {
    if (this.contract && this.contract.id) {
      this.handleFetchData(this.contract.id)
    }
  },
  methods: {
    async handleFetchData () {
      this.items = await getVariationsForContract(this.contract.id, 'variation')
    }
  },
  watch: {
    contract () {
      this.handleFetchData()
    }
  }
}
</script>
